import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userNameDataFilter',
})
export class userNamePipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, (row) => 
        (row.name?.toLowerCase().indexOf(query.toLowerCase()) > -1 || 
        row.mobile?.indexOf(query.toLowerCase().replaceAll(" ","")) > -1 || row.email?.indexOf(query) > -1 || 
        row.username?.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        row.facilityName?.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        row.nameEn?.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        row.dayName?.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        row.country_code?.indexOf(query.toLowerCase().replaceAll(" ","")) + row.mobile?.indexOf(query.toLowerCase().replaceAll(" ","")) > -1 
        )
      );
    }
    return array;
  }
}


